import loyalty from './loyalty/loyalty';
import navigation from './navigation/navigation';
import loyaltyprogram from './loyaltyprogram/loyaltyprogram';
import signup from './signup/signup';
import pointshistory from './pointshistory/pointshistory';
import session from './session/session';
import theme from './theme/theme';


const loyaltyReducer = {
    loyalty,
    navigation,
    loyaltyprogram,
    signup,
    pointshistory,
    session,
    theme,
}
export default loyaltyReducer;
